var map = {
	"./activity-color.svg": "e091",
	"./activity-gray.svg": "da81",
	"./bank-color.svg": "837f",
	"./bank-gray.svg": "fa0a",
	"./calendar-color.svg": "af97",
	"./calendar-gray.svg": "97dd",
	"./call-forwarding-color.svg": "f2e8",
	"./call-forwarding-gray.svg": "74b6",
	"./campaign-report-color.svg": "914d",
	"./campaign-report-gray.svg": "f98a",
	"./campaigns-color.svg": "8047",
	"./campaigns-gray.svg": "a875",
	"./checkboxes-color.svg": "0cd2",
	"./checkboxes-gray.svg": "a414",
	"./combine-contact-sources-color.svg": "8877",
	"./combine-contact-sources-gray.svg": "d20d",
	"./completed-tasks-color.svg": "30e9",
	"./completed-tasks-gray.svg": "e8c5",
	"./contacts-color.svg": "fd1b",
	"./contacts-gray.svg": "2f4b",
	"./custom-campaign-color.svg": "07ed",
	"./custom-campaign-gray.svg": "e2c4",
	"./custom-fields-color.svg": "9a23",
	"./custom-fields-gray.svg": "41ea",
	"./download-app-color.svg": "cb79",
	"./download-app-gray.svg": "b86a",
	"./download-contacts-color.svg": "5f96",
	"./download-contacts-gray.svg": "e1c2",
	"./download-contacts-success-color.svg": "f90d",
	"./download-contacts-success-gray.svg": "f507",
	"./email-broadcasts-color.svg": "1413",
	"./email-broadcasts-gray.svg": "91eb",
	"./export-color.svg": "e274",
	"./export-gray.svg": "ce6e",
	"./fast-followup-color.svg": "baac",
	"./fast-followup-gray.svg": "bb7e",
	"./followup-color.svg": "5edc",
	"./followup-gray.svg": "77a0",
	"./form-appointment-color.svg": "ba41",
	"./form-appointment-gray.svg": "2413",
	"./form-checkout-color.svg": "3790",
	"./form-checkout-gray.svg": "768f",
	"./form-internal-color.svg": "a9b3",
	"./form-internal-gray.svg": "b2cf",
	"./form-public-color.svg": "928c",
	"./form-public-gray.svg": "0a8c",
	"./happy-browser-color.svg": "09d4",
	"./happy-browser-gray.svg": "a4ed",
	"./import-contacts-color.svg": "6947",
	"./import-contacts-gray.svg": "0faa",
	"./leads-color.svg": "0249",
	"./leads-gray.svg": "b250",
	"./location-lookup-color.svg": "8d7d",
	"./location-lookup-gray.svg": "8527",
	"./messenger-color.svg": "c850",
	"./messenger-gray.svg": "53b3",
	"./money-color.svg": "664a",
	"./money-gray.svg": "a4f1",
	"./new-contact-color.svg": "c769",
	"./new-contact-gray.svg": "e130",
	"./notes-color.svg": "9596",
	"./notes-gray.svg": "412a",
	"./oops-color.svg": "5a62",
	"./oops-gray.svg": "cc47",
	"./phone-number-ready-color.svg": "22f1",
	"./phone-number-ready-gray.svg": "3090",
	"./pipeline-color.svg": "cc5d",
	"./pipeline-gray.svg": "22eb",
	"./promote-color.svg": "e1c6",
	"./promote-gray.svg": "b2eb",
	"./sad-calendar-color.svg": "a602",
	"./sad-calendar-gray.svg": "d31d",
	"./sales-invoice-color.svg": "87a6",
	"./sales-invoice-gray.svg": "e9b6",
	"./sales-promo-code-color.svg": "72af",
	"./sales-promo-code-gray.svg": "150e",
	"./sales-quote-color.svg": "3975",
	"./sales-quote-gray.svg": "33d7",
	"./sales-recurring-payment-color.svg": "dab7",
	"./sales-recurring-payment-gray.svg": "31c4",
	"./sales-upsell-color.svg": "47f0",
	"./sales-upsell-gray.svg": "ae46",
	"./scan-contact-color.svg": "2bc7",
	"./scan-contact-gray.svg": "7aef",
	"./segment-color.svg": "ddc8",
	"./segment-gray.svg": "b688",
	"./setup-messenger-color.svg": "01d4",
	"./setup-messenger-gray.svg": "d859",
	"./simple-text-gray.svg": "5aa8",
	"./single-messenger-color.svg": "1ec8",
	"./single-messenger-gray.svg": "8b45",
	"./success-confetti-color.svg": "2475",
	"./success-confetti-gray.svg": "2014",
	"./success-high-five-color.svg": "b25b",
	"./success-high-five-gray.svg": "9c34",
	"./success-sent-color.svg": "09df",
	"./success-sent-gray.svg": "6516",
	"./success-thumbs-up-color.svg": "351a",
	"./success-thumbs-up-gray.svg": "919c",
	"./successful-payment-color.svg": "e612",
	"./successful-payment-gray.svg": "fa32",
	"./tasks-color.svg": "1b5b",
	"./tasks-gray.svg": "a332",
	"./three-emails-color.svg": "b295",
	"./three-emails-gray.svg": "63ce",
	"./untranscribable-image-color.svg": "11f7",
	"./untranscribable-image-gray.svg": "e015",
	"./upload-color.svg": "04a9",
	"./upload-gray.svg": "2e6b",
	"./voice-messenger-color.svg": "eb9e",
	"./voice-messenger-gray.svg": "8f37"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "92e4";